import { jsx as _jsx } from "react/jsx-runtime";
// @ts-ignore-next-line importsNotUsedAsValues
import 'react';
import classNames from 'classnames';
import { isEmpty } from 'lodash';
import ButtonDropdown from '../dropdown/ButtonDropdown';
import SimpleTooltip from '../tooltip/SimpleTooltip';
const TreeOptions = (props) => {
    const { treeOptions = [], treeOptionsTooltip, className } = props;
    if (isEmpty(treeOptions)) {
        return null;
    }
    const dropdownClasses = classNames('display-flex flex-column gap-10', 'width-250', 'padding-15', className);
    const customDropdown = _jsx("div", Object.assign({ className: dropdownClasses }, { children: treeOptions }));
    const dropdown = (_jsx(ButtonDropdown, { title: _jsx("span", { className: 'rioglyph rioglyph-option-vertical', "aria-hidden": 'true' }), bsStyle: 'default', bsSize: 'sm', customDropdown: customDropdown, toggleClassName: 'hover-bg-white border-none text-color-gray hover-text-color-dark', className: 'TreeHeaderOptions height-20', pullRight: true, iconOnly: true }));
    if (treeOptionsTooltip) {
        return (_jsx(SimpleTooltip, Object.assign({ content: treeOptionsTooltip, placement: 'bottom', delay: { show: 1000, hide: 0 }, popperConfig: {
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [-20, 10],
                        },
                    },
                ],
            } }, { children: dropdown })));
    }
    return dropdown;
};
export default TreeOptions;
